import { TOWPRO_TOW_REASONS } from '@rsos/reduxDataStore/src/features/resourceRequests';

export interface TowProFormValues {
  address: string;
  latitude: number | null;
  longitude: number | null;
  region_id: string;
  reason: string;
  related_call: string;
  vin: string;
  make: string;
  model: string;
  vehicle_year: string;
  color: string;
  license_plate_number: string;
  license_plate_state: string;
  incident_number: string;
  agency_id: string;
  officer_name: string;
  badge_number: string;
  owner_first_name: string;
  owner_last_name: string;
  owner_phone: string;
  owner_street: string;
  owner_apt: string;
  owner_city: string;
  owner_state: string;
  owner_zip: string;
  notes: string;
}

export const TOWPRO_INITIAL_FORM_VALUES: TowProFormValues = {
  address: '',
  latitude: null,
  longitude: null,
  region_id: '',
  reason: '',
  related_call: '',
  vin: '',
  make: '',
  model: '',
  vehicle_year: '',
  color: '',
  license_plate_number: '',
  license_plate_state: '',
  incident_number: '',
  agency_id: '',
  officer_name: '',
  badge_number: '',
  owner_first_name: '',
  owner_last_name: '',
  owner_phone: '',
  owner_street: '',
  owner_apt: '',
  owner_city: '',
  owner_state: '',
  owner_zip: '',
  notes: '',
};

export interface TowProSelectOption {
  value: string;
  label: string;
}

export const TOWPRO_REASON_OPTIONS: TowProSelectOption[] =
  TOWPRO_TOW_REASONS.map(reason => ({ value: reason, label: reason }));

export const VIN_LENGTH = 17;
